import React from "react";
import DOMPurify from "dompurify";

type SvgQuestionRendererProps = {
  svgCode: string;
  questionText?: string;
  className?: string;
  noMargin?: boolean;
};

const SvgQuestionRenderer: React.FC<SvgQuestionRendererProps> = ({
  svgCode,
  questionText,
  className,
  noMargin = false,
}) => {
  if (!svgCode || !svgCode.trim().startsWith("<svg")) {
    return null;
  }

  const sanitizedSvg = DOMPurify.sanitize(svgCode, { USE_PROFILES: { svg: true, svgFilters: true } });

  return (
    <div
      className={`${noMargin ? "" : "mb-4"} max-w-[380px] [&>svg]:w-full [&>svg]:h-auto rounded-xl border border-slate-200 bg-white ${className || ""}`}
      role="img"
      aria-label={questionText ? `Visual for: ${questionText}` : "Question visual"}
      dangerouslySetInnerHTML={{ __html: sanitizedSvg }}
    />
  );
};

export default SvgQuestionRenderer;
